import { FC, useContext, useEffect, useRef } from "react";

import { FormType } from "@simplyk/common";
import { useSearchParams } from "next/navigation";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { FrontendFormContext } from "@/common/contexts/FrontendFormContext";

export const DafPaymentResume: FC = () => {
  const token = useSearchParams().get("dafToken");
  const initialized = useRef(false);
  const { setDafFlow } = useContext(FrontendFormContext);
  const { setCurrentStep } = useFormV2Context(FormType.DonationForm);
  // Resume tokens are read after hydration so no donor data enters the shared form HTML.
  useEffect(() => {
    if (token && !initialized.current) {
      initialized.current = true;
      setDafFlow({ token, isResume: true });
      setCurrentStep("payment");
    }
  }, [token, setDafFlow, setCurrentStep]);
  return null;
};
